"use client";

import { ApolloClient, InMemoryCache, HttpLink } from "@apollo/client";

const apiOrigin = (
  process.env.NEXT_PUBLIC_API_ORIGIN || "http://localhost:5000"
).replace(/\/$/, "");

export const apolloClient = new ApolloClient({
  link: new HttpLink({
    uri: `${apiOrigin}/graphql`,
    credentials: "include", // CRITICAL — session cookie must be sent with every mutation
  }),
  cache: new InMemoryCache(),
});
